// Mantine
import { Button, Modal, TextInput } from '@mantine/core'
import { useDisclosure } from '@mantine/hooks'

// React
import { useState, useEffect } from 'react'

export default function FulfillmentOrderAssociateWarranty({
    line,
    associateWarranty,
    watchHeadId,
    warrantyCodeToAssociate,
    size = 'sm',
    label = 'Associer une garantie',
}) {
    // Modal
    const [opened, handlers] = useDisclosure(false)
    const [isLoading, setIsLoading] = useState(false)

    // States
    const [codeToAddValue, setCodeToAddValue] = useState('WA')

    // Open modal
    useEffect(() => {
        if (opened) {
            setCodeToAddValue('WA')
        }
    }, [opened])

    // Manual add
    const canAddCode = codeToAddValue.length > 5

    const codeToAddValueHandler = (e) => {
        // Check that code is only alphanumeric
        const cleanedValue = e.target.value
            .replace(/[^a-zA-Z0-9]/g, '')
            .toUpperCase()

        if (cleanedValue.length < 11 && cleanedValue.startsWith('WA')) {
            setCodeToAddValue(cleanedValue)
        }
    }

    const submit = async () => {
        const productVariantId = line.shopify_product_variant?.id

        // If line is associated to a product
        if (directAssociateWarranty && canAddCode) {
            setIsLoading(true)

            const res = await associateWarranty({
                code: codeToAddValue,
                component_id: watchHeadId,
                shopify_product_variant_id: productVariantId,
            })

            setIsLoading(false)
        }
    }

    const directAssociateWarranty = async () => {
        const productVariantId = line.shopify_product_variant?.id

        setIsLoading(true)

        const res = await associateWarranty({
            code: warrantyCodeToAssociate,
            component_id: watchHeadId,
            shopify_product_variant_id: productVariantId,
        })

        setIsLoading(false)
    }

    return (
        <>
            <Modal
                opened={opened}
                title={'Associer une garantie'}
                onClose={handlers.close}
            >
                <div className="flex flex-col gap-2">
                    <span className="text-lg font-medium">{line.name}</span>

                    <TextInput
                        value={codeToAddValue}
                        onChange={codeToAddValueHandler}
                        placeholder="WA123456789"
                        label="Code de garantie"
                        description="Saisissez le code de garantie à associer à la commande"
                    />

                    <Button
                        disabled={!canAddCode}
                        variant="default"
                        onClick={submit}
                        loading={isLoading}
                        fullWidth
                    >
                        Associer la garantie
                    </Button>
                </div>
            </Modal>

            {!warrantyCodeToAssociate && (
                <Button onClick={handlers.open} variant="light" color="orange" size={size}>
                    {label}
                </Button>
            )}

            {warrantyCodeToAssociate && (
                <Button
                    variant="light"
                    color="orange"
                    loading={isLoading}
                    onClick={directAssociateWarranty}
                >
                    Associer {warrantyCodeToAssociate}
                </Button>
            )}
        </>
    )
}
